import { DatabaseOperationEnum } from '../../../enums/database-operation.enum';
import { AppSubjectEnum } from '../../../modules/authz/enums/app-subject.enum';
import { ActivityEventTypeEnum } from '../enums/activity-event-type.enum';
import { ActivityChangedLinksDto } from './activity-changed-links.dto';
import { ActivityStatusChangeDto } from './activity-status-change.dto';

/**
 * A single activity (audit) event for a record, with raw before/after snapshots.
 */
export class ActivityEventDto {
  id!: number;
  subject!: AppSubjectEnum;
  subjectId!: number;
  operation!: DatabaseOperationEnum;
  eventType!: ActivityEventTypeEnum;
  occurredAt!: Date;
  userId!: number;
  userName?: string;
  changedFields!: string[];
  before?: Record<string, any>;
  after?: Record<string, any>;
  changedLinks?: ActivityChangedLinksDto;
  statusChange?: ActivityStatusChangeDto;
  snapshotAction?: {
    event?: string;
    recipient?: string;
    correlationId?: string;
    eventId?: number;
    errorCode?: string;
  };
}
